import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { AbstractBaseFieldComponent } from '@shared/components/form-elements/abstract-field-base';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'cx-multi-select-field',
  imports: [CommonModule, FormsModule, MultiSelectModule, FormErrorsModule],
  templateUrl: './multi-select-field.component.html',
  styleUrls: ['./multi-select-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectFieldComponent),
      multi: true,
    },
  ],
  host: {
    '[attr.id]': 'null',
  },
})
export class MultiSelectFieldComponent extends AbstractBaseFieldComponent implements ControlValueAccessor, OnInit {
  @Input() control?: AbstractControl | null;
  @Input() label = '';
  @Input() hintText = '';
  @Input() icon = '';
  @Input() id = this.generateId();
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() valid?: boolean;
  @Input() invalid?: boolean;
  @Input() items: any[] = [];
  @Input() bindLabel = 'label';
  @Input() bindValue = 'value';
  @Input() loading = false;
  @Input() typeahead = new Subject<string>();

  @Output() scrollToEnd = new EventEmitter<void>();
  @Output() columnScroll = new EventEmitter<NgSelectComponent>();

  @ViewChild('selectContent', { static: true }) myNgSelect?: NgSelectComponent;

  override value?: string | undefined;

  override writeValue(value: any): void {
    this.value = value || undefined;
  }

  selectedItems: any[] = [];
  mock = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' },
  ];

  ngOnInit(): void {
    this.columnScroll.emit(this.myNgSelect);
  }

  onChangeSelect(event: Event): void {
    this.onChange(event);
  }
}
